import React, { useEffect, useState } from 'react';

import { jwtDecode } from 'jwt-decode';
import PropertylistFeatured from './Propertylist/PropertylistFeatured';
import NavBar from './componance/NavBar';
import Footer from './componance/Footer';
import SearchForm from './componance/Search/SearchForm';
import PropertyListFav from './Propertylist/PropertyListFav';
import LoginModal from './componance/Login/LoginModal';
import PropertyImagesModal from './componance/Modal/PropertyImagesModal';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from 'react-i18next';
import PropertyListContainer from './Propertylist/PropertyListContainer';
import ContactPopupWithArrow from './componance/ContactPopupWithArrow';
import IntroSection from './componance/IntroSection';
import { useSearchParams } from 'react-router-dom';
import i18n from './i18n';
import EstimatedYield from './componance/Modal/EstimatedYield';
import DetailModalProperty from './componance/Modal/DetailModalProperty';
import DetailModalHeader from './componance/Modal/DetailModalHeader';
import BannerSection from './componance/Banner/BannerSection';
import DetailModalPropertyhead from './componance/Modal/DetailModalPropertyhead'
import ReviewHome from './componance/reviews/ReviewHome';
import { useAuth } from './Authen/AuthContext';

function HomePage() {
  const [userId, setUserId] = useState(null);
  const [properties, setProperties] = useState([]);
  const [selectedType, setSelectedType] = useState('all');
  const [status, ] = useState('all');
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null); 
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [favoriteProperties, setFavoriteProperties] = useState([]);
  const [currency, setCurrency] = useState(localStorage.getItem('currency') || 'THB');
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [priceFilter, ] = React.useState(null);
  const [bedroomFilter, setBedroomFilter] = React.useState(null);
const [searchParams, setSearchParams] = useSearchParams();
const [searchResults, ] = useState([]);
 const [propertyStatus, setPropertyStatus] = useState('all');
const [reviews, setReviews] = useState([]);
const { user } =  useAuth(); // ✅ เพิ่มตรงนี้

  const { t } = useTranslation();

  // ✅ เพิ่ม state สำหรับ Drawer
  const [showFavDrawer, setShowFavDrawer] = useState(false);
const shuffleArray = (array) => {
  return [...array].sort(() => Math.random() - 0.5);
};
const randomProperties = shuffleArray(filteredProperties);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserId(decoded.userId || decoded.user_id);
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
  }, []);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => { document.body.style.overflow = 'auto'; };
  }, [isModalOpen]);

  // โหลด favorites จาก DB
useEffect(() => {
    if (!userId) return;
    fetch(`https://summerhousagentlive.onrender.com/api/favorites/${userId}`)
      .then(res => res.json())
      .then(data => setFavoriteProperties(data))
      .catch(err => console.error(err));
  }, [userId]);

 useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch(`https://summerhousagentlive.onrender.com/api/reviews`);
        const data = await res.json();

        if (data.reviews) {
          const latest = data.reviews
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            .slice(0, 3);
          setReviews(latest);
        }
      } catch (err) {
        console.error("Error loading reviews:", err);
      }
    };

    fetchReviews();
  }, []);


  useEffect(() => {
    fetch('https://summerhousagentlive.onrender.com/api/properties')
      .then(response => response.json())
      .then(data => {
        const propsArray = Array.isArray(data) ? data : [];
        setProperties(propsArray);
        setFilteredProperties(propsArray);
      })

      .catch(error => console.error('Error fetching data:', error));
  }, []);
  
 const openModal = React.useCallback((property) => {
  setSelectedProperty(property);
  setIsModalOpen(true);

  // เพิ่ม query
  setSearchParams({ property: property.property_id });
}, [setSearchParams]);
const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProperty(null);
     setSearchParams({});
  };


  
  useEffect(() => {
  const propId = searchParams.get('property');
  if (propId) {
    const prop = properties.find(p => p.property_id === Number(propId));
    if (prop) openModal(prop);
  }
}, [searchParams, properties, openModal]);






  const handleSearch = () => {
  const filtered = properties.filter(property => {
    
            const matchesType = selectedType === 'all' || property.type === selectedType;
            const matchesLocation = selectedLocations.length === 0 || selectedLocations.includes(property.location);
            const matchesStatus = status === 'all' || property.status === status;
            const isPriceMatch = (price, filter) => {
              if (!filter) return true;
              const priceNumber = Number(price);
              switch(filter) {
                case '<2000000': return priceNumber < 2000000;
                case '2-5M': return priceNumber >= 2000000 && priceNumber <= 5000000 ;
                case '5-10M': return priceNumber >= 5000000  && priceNumber <= 10000000;
                 case '10-20M': return priceNumber >= 10000000  && priceNumber <= 20000000;
                case '>20M': return priceNumber > 20000000;
                default: return true;
              }

              
            };

            // ใช้ใน handleSearch
            let matchesPrice = isPriceMatch(property.price, priceFilter);


            let matchesBedroom = true;
            if (bedroomFilter) {
              const bedroomCount = Number(property.bedroom || property.bedrooms || 0);
              matchesBedroom = bedroomFilter === '4+' ? bedroomCount >= 4 : bedroomCount === Number(bedroomFilter);
            }

            return matchesType && matchesLocation && matchesStatus && matchesPrice && matchesBedroom ;
          });

          setFilteredProperties(filtered);
        };


 

   const toggleFavorite = (property) => {
    if (!userId) { setShowLoginPopup(true); return; }

    const isFav = favoriteProperties.some(fav => fav.property_id === property.property_id);

    if (isFav) {
      fetch(`https://summerhousagentlive.onrender.com/api/favorites/${userId}/${property.property_id}`, { method: 'DELETE' })
        .then(() => setFavoriteProperties(prev => prev.filter(fav => fav.property_id !== property.property_id)));
    } else {
      fetch(`https://summerhousagentlive.onrender.com/api/favorites`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, property_id: property.property_id })
      }).then(() => setFavoriteProperties(prev => [...prev, property]));
    }
  };


return (
                 <div style={styles.container}>
                    <NavBar currency={currency} setCurrency={setCurrency}/>
                
                   <div style={{ position: 'relative', width: '100vw', maxWidth: '100vw', height: '100vh', overflow: 'hidden', margin: 0, padding: 0 }}>
                      {/* Desktop Video */}
                            <iframe
                              src="https://www.youtube.com/embed/izNz10smqBc?autoplay=1&mute=1&loop=1&playlist=izNz10smqBc&controls=0&modestbranding=1&showinfo=0&rel=0"
                              title="Background Video Desktop"
                              frameBorder="0"
                              allow="autoplay; fullscreen; picture-in-picture"
                              allowFullScreen
                              className="desktop-video"
                              style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                width: '120%', // ขยายกว้างขึ้น
                                height: '120vh', // ขยายสูงขึ้น
                                transform: 'translate(-50%, -50%)',
                                objectFit: 'cover', // ทำให้เต็มพื้นที่
                                pointerEvents: 'none',
                                zIndex: 0,
                              }}
                            ></iframe>

                    {/* Mobile Video */}
                            <iframe
                              src="https://www.youtube.com/embed/j6GGdySpY3Q?autoplay=1&mute=1&loop=1&playlist=j6GGdySpY3Q&controls=0&modestbranding=1&showinfo=0&rel=0"
                              title="Background Video Mobile"
                              frameBorder="0"
                              allow="autoplay; fullscreen; picture-in-picture"
                              allowFullScreen
                              className="mobile-video"
                              style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                width: '177.77vw',
                                height: '100vh',
                                transform: 'translate(-50%, -50%)',
                                pointerEvents: 'none',
                                zIndex: 0,
                                filter: 'brightness(0.6) contrast(1.1)', // ✅ ทำให้ข้อความเด่นขึ้น
                                willChange: 'transform',
                                backfaceVisibility: 'hidden',
                              }}
                            ></iframe>

                            {/* Overlay สำหรับช่วยให้ text ชัดขึ้น */}
                            <div
                              className="video-overlay"
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                background: 'rgba(0, 0, 0, 0.35)', // ✅ ดำโปร่งนิดๆ ให้ text เด่นขึ้น
                                zIndex: 1,
                                pointerEvents: 'none',
                              }}
                            ></div>

                            <style>{`
                              /* Default: แสดง Desktop video, ซ่อน Mobile video */
                              .desktop-video {
                                display: block;
                              }
                              .mobile-video {
                                display: none;
                              }

                              /* Mobile: ซ่อน Desktop video, แสดง Mobile video */
                              @media (max-width: 768px) {
                                .desktop-video {
                                  display: none;
                                }
                                .mobile-video {
                                  display: block;
                                }
                                /* ทำให้ overlay เข้มขึ้นบนมือถือ */
                                .video-overlay {
                                  background: rgba(0, 0, 0, 0.45);
                                }
                              }
                            `}</style>

                            <div
                              style={{
                                position: 'relative',
                                zIndex: 10, // ✅ สูงกว่า overlay และ video
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                isolation: 'isolate', // ✅ ป้องกันการ blend กับ video layer
                                color: '#ffffff',
                                padding: '0 20px',
                                textAlign: 'center',
                              }}
                            >
                              <h1
                                style={{
                                  fontSize: '6vh',
                                  fontWeight: '700',
                                  marginBottom: '20px',
                                 marginLeft: -35,
                                  lineHeight: '1.2',
                                  letterSpacing: '1px',
                                  color: '#ffffff',
                                  textShadow: '2px 2px 8px rgba(0, 0, 0, 0.7)', // ✅ เพิ่มเงาให้ชัดขึ้น
                                  maxWidth: '90%',
                                  wordWrap: 'break-word',
                                  backfaceVisibility: 'hidden', // ✅ แก้ bug rendering บน Safari
                                  willChange: 'opacity, transform',
                                }}
                              >
                                {t('welcome')}
                              </h1>


                    {/* กล่อง SearchForm */}
                          <div
                            style={{
                              position: 'relative',
                              marginTop: '20px', // เว้นระยะห่างจากข้อความ welcome
                              backgroundColor: 'rgba(255, 255, 255, 0.52)', // พื้นหลังขาวโปร่ง
                              padding: '20px',
                              borderRadius: '20px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: '90%',
                              maxWidth: '400px',
                              boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                              marginLeft: -35,
                              zIndex: 2,
                            }}
                          >
                            <SearchForm
                              properties={properties}
                              selectedLocations={selectedLocations}
                              setSelectedLocations={setSelectedLocations}
                              selectedType={selectedType}
                              setSelectedType={setSelectedType}
                              status={propertyStatus}
                              setStatus={setPropertyStatus}
                              bedroomFilter={bedroomFilter}
                              setBedroomFilter={setBedroomFilter}
                              setFilteredProperties={setFilteredProperties}
                            />
                          </div>


                        </div>
                      </div>

                  
                    




                     <h1 style={styles.header}>{t('feature_property')}</h1>
                         <PropertylistFeatured
                                properties={filteredProperties} 
                                favorites={favoriteProperties} 
                                openModal={openModal} 
                                toggleFavorite={toggleFavorite} 
                                currency={currency} 
                         ></PropertylistFeatured>
                      {/* Location Filter Section */}
                     <div
  style={{
    position: "relative", // ตัว container ต้อง relative
    width: "100%",
    minHeight: "30vh",
    overflow: "hidden",
  }}
>
  {/* Background Blur */}
  <div
    style={{
         position: "absolute", // เปลี่ยนเป็น fixed ให้เต็ม viewport
      top: 10,
      left: 0,
      width: "100vw",   // เต็มความกว้างหน้าจอ
      height: "100vh",  // เต็มความสูงหน้าจอ

      backgroundSize: "cover",
      backgroundPosition: "center",
      filter: "blur(10px)",
      zIndex: -1,
         marginTop: "60px",
         marginBottom: "30px",
    }}
  ></div>

                <h2
                  style={{
                    fontSize: "32px",
                    fontWeight: "700",
                    marginBottom: "20px",
                    fontFamily: "'Roboto Condensed', 'Kanit', sans-serif",
                     position: "relative",
                    zIndex: 1,
                    textAlign: "center",
                    padding : "auto ",
                 
                  }}
                >
                  {t("popular_locations")}
                </h2>

                <div
                style={{
                  maxWidth: "1200px",
                  margin: "0 auto",
                  padding: "20px 20px", // ระยะขอบซ้ายขวา
                }}
              >
                <div className="location-grid">
                  {[
                    { name: t("Wichit"), image: "/img/Wichit.jpg" },
                    { name: t("Chalong"), image: "/img/Chalong.jpg" },
                    { name: t("Rawai"), image: "/img/rawai.jpg" },
                    { name: t("Kathu"), image: "/img/Kathu.jpg" },
                    { name: t("Patong"), image: "/img/patong.jpg" },
                    { name: t("Cherng Talay"), image: "/img/laguna.jpg" },
                  ].map((loc, idx) => (
                    <div
                      key={idx}
                      onClick={() => {
                        setSelectedLocations([loc.name]);
                        handleSearch();
                      }}
                      style={{
                        position: "relative",
                        borderRadius: "15px",
                        overflow: "hidden",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        width: "100%", // เต็ม column
                      }}
                    >
                      <img
                        src={loc.image}
                        alt={loc.name}
                        style={{ width: "100%", height: "180px", objectFit: "cover" }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0",
                          left: "0",
                          right: "0",
                          padding: "15px",
                          background:
                            "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                          color: "#fff",
                        }}
                      >
                        <h3 style={{ fontSize: "20px", fontWeight: "700" }}>{loc.name}</h3>
                      </div>
                    </div>
                  ))}
                </div>

                {/* CSS Grid */}
                <style>
                  {`
                    .location-grid {
                      display: grid;
                      gap: 20px; /* ระยะห่างระหว่าง item */
                      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
                    }

                    @media (min-width: 768px) {
                      .location-grid {
                        grid-template-columns: repeat(6, 1fr); /* Desktop */
                      }
                    }

                    @media (max-width: 767px) {
                      .location-grid {
                        grid-template-columns: repeat(2, 1fr); /* Mobile */
                      }
                    }
                  `}
                </style>
              </div>

</div>

     
                      {isModalOpen && selectedProperty && (
                      <>
                        {/* พื้นหลังดำโปร่ง */}
                        <div
                          style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: 'rgba(0,0,0,0.6)',
                            zIndex: 1000,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                          onClick={closeModal}
                        />

                        {/* กล่อง Modal */}
                        <div
                          style={{
                            backgroundColor: '#fff',
                            borderRadius: '16px',
                            padding: '24px',
                            width: '95%',
                            maxWidth: '700px',
                            maxHeight: '90vh',
                            overflowY: 'auto',
                            boxShadow: '0 8px 25px rgba(0,0,0,0.2)',
                            position: 'fixed',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 1100,
                            color: 'black',
                          }}
                          onClick={(e) => e.stopPropagation()}
                          >
                          
                          <DetailModalHeader
                            closeModal={closeModal}
                            selectedProperty={selectedProperty}
                            t={t}
                            i18n={i18n}
                          />
                          
                          <DetailModalPropertyhead
                            closeModal={closeModal}
                            selectedProperty={selectedProperty}
                            t={t}
                            i18n={i18n}/>

                          
                          {/* Slider ภาพอสังหาริมทรัพย์ */}
                          {selectedProperty.images && selectedProperty.images.length > 0 && (
                            <div
                              style={{
                                width: '100%',
                                maxWidth: '685px',
                                height: '400px',
                                margin: '0 auto 20px auto',
                                overflow: 'hidden',
                                borderRadius: '12px',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                              }}
                            >  
                              <PropertyImagesModal
                                images={selectedProperty.images}
                                propertyName={selectedProperty.name}
                              />
                             
                            </div>
                          )}
                          {/* รายละเอียดอสังหาริมทรัพย์ */}
                            <DetailModalProperty
                            selectedProperty={selectedProperty}
                            currency={currency}
                            t={t}
                              filteredProperties={filteredProperties} // ✅ เพิ่มบรรทัด
                          />
                        
                        

                          {/* Estimated Yield Section */}
                          {selectedProperty && (
                            <EstimatedYield selectedProperty={selectedProperty} />
                          )}

                          {/* ปุ่มปิด Modal */}
                          <button
                            onClick={closeModal}
                            style={{
                              marginTop: '20px',
                              backgroundColor: '#1a2e35',
                              color: '#fff',
                              padding: '10px 20px',
                              border: 'none',
                              borderRadius: '8px',
                              cursor: 'pointer',
                              fontWeight: '600',
                              fontSize: '1rem',
                              transition: 'all 0.3s',
                              display: 'block',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0f1c20')}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#1a2e35')}
                          >
                            {t("close")}
                          </button>
                        </div>
                      </>
                    )}

                   <IntroSection
                      t={t}
                      centerTextKey="intro_text"
                  /*   leftLinks={[
                        { titleKey: 'card1_title', descKey: 'card1_desc', path: '/topic1' },
                        { titleKey: 'card2_title', descKey: 'card2_desc', path: '/topic2' },
                        { titleKey: 'card3_title', descKey: 'card3_desc', path: '/topic3' },
                      ]}
                      rightLinks={[
                        { titleKey: 'card4_title', descKey: 'card4_desc', path: '/topic4' },
                        { titleKey: 'card5_title', descKey: 'card5_desc', path: '/topic5' },
                        { titleKey: 'card6_title', descKey: 'card6_desc', path: '/topic6' },
                      ]}  */
                    />

                            <div
                                id="searchResults"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                }}
                              >
                                <h1 style={styles.header}>{t("PropertyList_Update")}</h1>

                                <PropertyListContainer
                                  filteredProperties={[...filteredProperties].sort(
                                    (a, b) => b.property_id - a.property_id
                                  )}
                                  openModal={openModal}
                                  favoriteProperties={favoriteProperties}
                                  toggleFavorite={toggleFavorite}
                                  currency={currency}
                                  results={searchResults}
                                />
                              </div>
                              <h1 style={styles.header}>{t('PropertyList')}</h1>
                              <PropertyListContainer 
                                filteredProperties={randomProperties} 
                                openModal={openModal} 
                                favoriteProperties={favoriteProperties} 
                                toggleFavorite={toggleFavorite} 
                                currency={currency} 
                              />
                                <BannerSection sections={sections}   style={{
                                width: '100vw',      // เต็มหน้าจอแนวนอน
                                maxWidth: '100vw',   // ป้องกันถูกจำกัดความกว้าง
                                margin: 0,           // เอา margin ออก
                                padding: 0,          // เอา padding ออก
                              }}/>
           
                   <h1 style={styles.header}>{t('Reviews')}</h1>
              <ReviewHome 
                reviews={reviews.slice(0, 3)} 
                properties={filteredProperties} 
                user={user} 
                handleDelete={(id) => console.log("Delete review", id)} 
                t={t} 
              />
            



   
                  
                      
                          {/* Drawer Favorites */}
                <div style={{
                  position: "fixed",
                  left: 0,
                  right: 0,
                  bottom: showFavDrawer ? 0 : "-100%",
                  height: "60vh",
                  backgroundColor: "#fff",
                  boxShadow: "0 -4px 12px rgba(191, 173, 173, 0.2)",
                  borderTopLeftRadius: "20px",
                  borderTopRightRadius: "20px",
                  transition: "bottom 0.4s ease-in-out",
                  zIndex: 1100,
                  overflowY: "auto",
                  padding: "20px"
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h2>{t("favorite_property")}</h2>
                    <button onClick={() => setShowFavDrawer(false)}>✕</button>
                  </div>
                  <PropertyListFav 
                    favorites={favoriteProperties}
                    openModal={openModal}
                    toggleFavorite={toggleFavorite}
                    currency={currency}
                  />
                  
                </div>
               <button onClick={() => setShowFavDrawer(true)} style={styles.favButton}>❤️</button>
                      <Footer />
                      {showLoginPopup && (
                      <LoginModal onClose={() => setShowLoginPopup(false)} />
                )}        <ContactPopupWithArrow />   {/* ปุ่มลูกศรลอยติดขอบ */}
                    </div>
                  );
                }
const sections = [
  {
    image: 'https://res.cloudinary.com/dto6jil1u/image/upload/v1758552007/properties/yx7ziibd8razzhwdwebr.jpg',
    title: 'Luxury Condo',
    subtitle: 'Discover the finest properties in Phuket',
    buttonText: 'View More',
    buttonLink: 'https://summerhouseagent.com/search?property=40',
    overlayColor: 'rgba(0,0,0,0.5)',
    align: 'center',
    textAlign: 'center',

  },
 
];

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px',
    paddingTop: '0px',
    paddingBottom: '0px',
    minHeight: '100vh',
  },

  filterRow: {
    display: 'flex',
    gap: '15px',
    alignItems: 'center',
  },

  locationDropdown: {
    flex: '1 1 1',
  },

  header: {
    fontSize: '36px',
    fontWeight: 'bold',
    marginBottom: '20px',
    letterSpacing: '1.2px', // ระยะห่างตัวอักษรเล็กน้อย
    textTransform: 'uppercase', // ตัวพิมพ์ใหญ่ทั้งหมด
    textShadow: '1px 1px 4px rgba(0,0,0,0.15)', // เงานุ่มๆ
   
    borderBottom: '3px solid #dd9e2aff', // เส้นทองด้านล่าง
    paddingBottom: '8px', // ระยะห่างระหว่างข้อความกับเส้น
    fontFamily: "'Roboto Condensed', 'Kanit', sans-serif"
  },

  searchForm: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '20px',
    color: 'black', // สีตัวอักษร
  },

  select: {
    flex: '1 1 1vh',
    minWidth: '10vh',
    padding: '4px',
    fontSize: '16px',
    borderRadius: '2px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
    marginTop: '10px',
    marginBottom: '10px',
  },

  button: {
    padding: '10px 20px',
    backgroundColor: '#2980B9',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
  },

  modal: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxHeight: '90vh', // จำกัดความสูงไม่เกิน viewport
    overflowY: 'auto', // ให้ scroll แนวตั้ง
    backgroundColor: '#fff',
    padding: '20px',
    zIndex: 1000,
    width: '90%',
    maxWidth: '600px',
    borderRadius: '10px',
    boxShadow: '0 0 10px rgba(0,0,0,0.3)',
  },
   favButton: {
    position: "fixed", bottom: 20, left: 20, backgroundColor: "rgba(30, 62, 93, 0.8)",
    color: "#fff", padding: 15, borderRadius: "50%", border: "none", cursor: "pointer", zIndex: 1200
  }
};

export default HomePage;
